import React, { useState, useEffect } from 'react';
import { PenTool, Clock, ChevronLeft, GraduationCap, FileText, Layers } from 'lucide-react';
import '../styles/Sidebar.css';

export function Sidebar({ module, setModule, subModule, setSubModule, seconds, setSeconds, sentenceCount, setSentenceCount, isOpen, toggleSidebar, disabled, menuData }) {
  const [subModules, setSubModules] = useState([]);

  useEffect(() => {
    if (Object.keys(menuData).length > 0 && !module) {
      const firstModule = Object.keys(menuData)[0];
      setModule(firstModule);
    }
  }, [menuData, module, setModule]);

  useEffect(() => {
    if (module && menuData[module]) {
      setSubModules(menuData[module]);
      if (menuData[module].length > 0 && !subModule) {
        setSubModule(menuData[module][0]);
      }
    } else {
      setSubModules([]);
      setSubModule('');
    }
  }, [module, menuData, subModule, setSubModule]);

  const handleModuleChange = (e) => {
    const selectedModule = e.target.value;
    setModule(selectedModule);
    if (menuData[selectedModule] && menuData[selectedModule].length > 0) {
      setSubModule(menuData[selectedModule][0]);
    } else {
      setSubModule('');
    }
  };

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''} ${disabled ? 'disabled' : ''}`}>
      <div className="sidebar-content">
        <div className="sidebar-header">
          <div className="logo">
            <PenTool size={32} />
            <h1>英語ドリル</h1>
          </div>
          {isOpen && !disabled && (
            <button className="close-sidebar" onClick={toggleSidebar} aria-label="Close sidebar">
              <ChevronLeft size={24} />
            </button>
          )}
        </div>
        <div className="sidebar-item">
          <label htmlFor="module">
            <Layers size={20} />
            モジュール
          </label>
          <select id="module" value={module} onChange={handleModuleChange} disabled={disabled}>
            {Object.keys(menuData).map((mod) => (
              <option key={mod} value={mod}>{mod}</option>
            ))}
          </select>
        </div>
        <div className="sidebar-item">
          <label htmlFor="subModule">
            <GraduationCap size={20} />
            クラス
          </label>
          <select id="subModule" value={subModule} onChange={(e) => setSubModule(e.target.value)} disabled={disabled || !module}>
            {subModules.map((sub) => (
              <option key={sub} value={sub}>{sub}</option>
            ))}
          </select>
        </div>
        <div className="sidebar-item">
          <label htmlFor="seconds">
            <Clock size={20} />
            表示 (秒)
          </label>
          <input
            id="seconds"
            type="number"
            value={seconds}
            onChange={(e) => setSeconds(Number(e.target.value))}
            min="1"
            disabled={disabled}
          />
        </div>
        <div className="sidebar-item">
          <label htmlFor="sentenceCount">
            <FileText size={20} />
            文章数
          </label>
          <select
            id="sentenceCount"
            value={sentenceCount}
            onChange={(e) => setSentenceCount(Number(e.target.value))}
            disabled={disabled}
          >
            {[5, 10, 15, 20, 30, 40,60,80,100].map((count) => (
              <option key={count} value={count}>{count}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}